<script setup>
import FetchPlanCardsComponent from '@/components/FetchPlanCardsComponent.vue';

</script>

<template>
  <div class="bg-primary text-basecolor py-8 md:py-24 sm:px-2 lg:px-4">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="max-w-4xl px-4">
        <h2 class="text-3xl font-bold tracking-tight">
          {{ $t('landingPage.prices.title') }}
        </h2>
        <p class="mt-12 text-2xl font-bold">
          {{ $t('landingPage.prices.subtitle') }}
        </p>
      </div>

      <FetchPlanCardsComponent class="px-4" />

      <div class="mt-12">
        <h2 class="mt-12 text-2xl font-bold">
          {{ $t('landingPage.prices.unsubscribe.title') }}
        </h2>
        <p class="mt-12 text-md">
          {{ $t('landingPage.prices.unsubscribe.text') }}
        </p>
      </div>
    </div>
  </div>
</template>
